import * as React from "react";

const SvgBites = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path
      d="M13.2873 8.9773L12.2958 9.0633L12.7505 9.518L9.51801 12.7505L9.04607 12.2785L8.97731 13.2873L3.46636 7.77633L2.66667 6.85341L3.5336 6.76608L3.05304 6.28552L6.28552 3.05303L6.76339 3.5309L6.85342 2.66666L7.75472 3.44473L13.2873 8.9773ZM10.5955 8.44051C10.468 8.31299 10.2612 8.31299 10.1337 8.44051L9.55649 9.01774L8.40196 7.8632L8.97926 7.28605C9.10678 7.15853 9.10678 6.95178 8.97926 6.82427C8.85175 6.69675 8.645 6.69675 8.51748 6.82427L7.94025 7.4015L6.78571 6.24696L7.36302 5.66981C7.49054 5.54229 7.49054 5.33554 7.36302 5.20802C7.2355 5.0805 7.02875 5.0805 6.90124 5.20802L5.20803 6.90123C5.08051 7.02875 5.08051 7.2355 5.20803 7.36301C5.33555 7.49053 5.54229 7.49053 5.66981 7.36301L6.24696 6.78571L7.4015 7.94024L6.82427 8.51747C6.69675 8.64499 6.69675 8.85174 6.82427 8.97926C6.95179 9.10678 7.15854 9.10678 7.28606 8.97926L7.86321 8.40195L9.01774 9.55649L8.44052 10.1337C8.313 10.2612 8.313 10.468 8.44052 10.5955C8.56803 10.723 8.77478 10.723 8.9023 10.5955L10.5955 8.90229C10.723 8.77477 10.723 8.56803 10.5955 8.44051Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgBites;
